import React from "react";
import { motion } from "framer-motion";

// A single chat bubble. Bot = light/left, user = blue/right.
//
// `image`, `failed` and `onRetry` are used by the AI assistant panel (photo
// questions and send failures); the guided data-entry flow passes only
// `from` and `text` and is unaffected by them.
const MessageBubble = ({ from, text, image, failed, onRetry, retryLabel = "Retry" }) => {
  const isBot = from === "bot";
  return (
    <motion.div
      initial={{ opacity: 0, y: 10, scale: 0.96 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ type: "spring", stiffness: 400, damping: 28 }}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: isBot ? "flex-start" : "flex-end",
        marginBottom: 8,
      }}
    >
      <div
        style={{
          maxWidth: "82%",
          padding: image && !text ? 4 : "9px 13px",
          borderRadius: 16,
          borderBottomLeftRadius: isBot ? 4 : 16,
          borderBottomRightRadius: isBot ? 16 : 4,
          background: isBot ? "#eef2ff" : "linear-gradient(135deg,#2563eb,#1d4ed8)",
          color: isBot ? "#1e293b" : "#fff",
          fontSize: 14,
          lineHeight: 1.45,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          opacity: failed ? 0.6 : 1,
          boxShadow: isBot
            ? "0 1px 2px rgba(30,41,59,0.06)"
            : "0 2px 8px rgba(37,99,235,0.30)",
        }}
      >
        {image && (
          <img
            src={image}
            alt=""
            style={{
              display: "block",
              width: "100%",
              maxWidth: 200,
              borderRadius: 12,
              marginBottom: text ? 8 : 0,
            }}
          />
        )}
        {text}
      </div>

      {failed && onRetry && (
        <button
          type="button"
          onClick={onRetry}
          style={{
            marginTop: 4,
            background: "none",
            border: "none",
            padding: "2px 4px",
            color: "#e11d48",
            fontSize: 12,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          {retryLabel}
        </button>
      )}
    </motion.div>
  );
};

export default MessageBubble;
